import store from "@/providers/store"
import vuexI18n from "vuex-i18n"

const registerLangs = Vue => {
  const req = require.context("@/Modules/", true, /Langs\/[^\\]*\.(ts|js)$/i)
  return req.keys().flatMap((key) => {
    let module = key.split("/")[1]
    let language = key.split("/")
    language = language[language.length - 1].split(".")[0]
    let translations = req(key).default
    Vue.i18n.add(language, { [module]: translations })
  })
}

export default {
  install (Vue) {
    Vue.use(vuexI18n.plugin, store)

    registerLangs(Vue)

    Vue.i18n.set("sl-SI")

    Vue.mixin({
      methods: {
        t (key) {
          // Clone arguments and return all but first argument
          let otherArgs = [...arguments]
          otherArgs.shift()
          // If the LangPath component option is set prepend it to the key
          if (this.$options.LangPath) return this.$t(this.$options.LangPath + "." + key, ...otherArgs)
          return this.$t(key, ...otherArgs)
        }
      }
    })
  }
}
